import { Button } from "@/components/ui/button"
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { useDeleteBoard } from "@/hooks/useBoard"
import { useToast } from "@/hooks/useToast"

interface DeleteBoardDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  boardId: string
  onSuccess?: () => void
}

export function DeleteBoardDialog({ open, onOpenChange, boardId, onSuccess }: DeleteBoardDialogProps) {
  const { toast } = useToast()
  const deleteBoard = useDeleteBoard()

  const handleDelete = async () => {
    if (!boardId) return
    try {
      await deleteBoard.mutateAsync(boardId)
      onOpenChange(false)
      toast({ description: "Board deleted successfully" })
      onSuccess?.()
    } catch (error: any) {
      toast({
        description: error?.response?.data?.error || "Failed to delete board",
        variant: "destructive",
      })
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete Board</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Are you sure you want to delete this board? This action cannot be undone.
        </p>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={handleDelete} disabled={deleteBoard.isPending}>
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
